import {Component, Input, Output, EventEmitter, Injectable, OnInit} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter} from '@angular/material/core';
import {DD_MM_YYYY_FORMAT} from '../date-formats';

@Injectable()
class ZeroPaddedDateAdapter extends NativeDateAdapter {
    override format(date: Date, displayFormat: string): string {
        if (displayFormat === 'dd-MM-yyyy') {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return super.format(date, displayFormat);
    }
}

@Component({
    selector: 'my-datepicker',
    template: `
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
                matInput
                [matDatepicker]="picker"
                [formControl]="dateControl"
                (dateChange)="onDateChange($event.value)"
                (click)="picker.open()"
                readonly/>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    `,
    styles: [`
        mat-form-field {
            width: 100%;
            background-color: white;
            --mat-form-field-container-height: 0;
            --mat-form-field-container-vertical-padding: 0.5rem;
        }

        ::ng-deep .mat-mdc-form-field-flex {
            align-items: center !important;
        }

        input {
            cursor: pointer;
            background-color: white;
            padding: 0 1rem;
        }
    `],
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        ReactiveFormsModule
    ],
    providers: [
        {provide: DateAdapter, useClass: ZeroPaddedDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT}
    ]
})
export class IsdDatepickerComponent implements OnInit {
    @Input() dateModel: Date | null = null;
    @Input() label: string = 'Selecteer een datum';
    @Output() dateModelChange = new EventEmitter<Date | null>();

    dateControl = new FormControl<Date | null>(null);

    ngOnInit(): void {
        this.dateControl.setValue(this.dateModel);
    }

    onDateChange(value: Date | null): void {
        this.dateModel = value;
        this.dateModelChange.emit(value);
    }
}
